// Give namespacing to allow legacy methods to work.
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Config from 'es6/core/config';
import {checkForStoredPresentationData} from 'es6/services/study-data-manager';
import Director from 'director';
import { partOfSpeech } from 'es6/helpers/localization';
import Logger from 'es6/services/logger';
import ContentController from 'es6/controllers/content';
import CoursesController from 'es6/controllers/courses';
import HomeController from 'es6/controllers/home';
import AccountEditController from 'es6/controllers/account-edit';
import Localization from 'es6/services/localization';
import createStore from 'es6/redux/stores/default';
import { initEnv } from 'es6/redux/modules/env';
import * as ImageManager from 'es6/services/image-manager';

// For the global namespace.
import * as API from 'es6/core/api';
import * as Errors from 'es6/core/errors';

const Helpers = { Localization: { partOfSpeech }};
const store = createStore();

// Make new APIs available to legacy front end components.
Object.assign(window.App, { API, Errors, Helpers });
Object.assign(window, { ImageManager, Localization });

// Callback method for when a route is found.
function route(controller, ...params) {
  // Instantiate the new router.
  Logger.info('Route Changed', 'Instantiating new router', params);
  new controller(store, ...params);
}

// Routes and callbacks for those routes.
const Routes = {
 '/content/([0-9a-zA-Z-_]+)/series/([0-9]+)': route.bind(this, ContentController),
 '/content/([0-9a-zA-Z-_]+)': route.bind(this, ContentController),
 '/courses/([0-9]+)': route.bind(this, CoursesController),
 '/home': route.bind(this, HomeController),
 '/account/edit': route.bind(this, AccountEditController),
};

function initialize() {
  store
  .dispatch(initEnv({ dispatchFlashMessages: false }))
  .then(() => determineRoute());
}

// Determine the appropriate route and execute the startup code.
function determineRoute() {
  // This is somewhat of a makeshift router. In the future, we will
  // want to use something like Director, but html5 push state is
  // not supported in IE9 as of now.
  let routeRegexps = Object.keys(Routes);

  for(let i = 0; i < routeRegexps.length; i++) {
    let regexp = routeRegexps[i];

    // Bound the regexp and allow for trailing slashes.
    let match = window.location.pathname.match(`^${regexp}[/]*$`);

    if (match) {
      Routes[regexp].apply(null, match.slice(1));
      break;
    }
  }
}

// Before loading anything, see if the user has any unsent presentation data.
// Whether or not there is an error, continue to load the page.
checkForStoredPresentationData(() => {}, initialize, initialize);
